/* eslint-disable */
import React, { useEffect, useState, useContext, useMemo } from 'react';

import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

//import translation function for language translation
import { useTranslation } from 'react-i18next';
//import context
import { GlobalProvider } from "context/GlobalContext";
/* import specific audience data */
import specificAudianceData from '../../data/SpecificAudienceData.json';

const SpecificAudienceBody = ({ downloadExcel }) => {
  const { screenHeight } = useContext(GlobalProvider);
  const { t } = useTranslation(); //for translation
  const [rowSelection, setRowSelection] = useState({});

  /* Handle the button's onClick event and set it to export the data by using the ExcelExport save method. */
  const exportExcel = () => {
    const exportData = specificAudianceData;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Specific Audiance.xlsx");
  };

  const tableColumns = useMemo(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: t("Name"),
        size: 200,
      },
      {
        id: "batch",
        accessorKey: "batch",
        header: t("Batch"),
        size: 200,
      },
    ],
    [t]
  );

  /* hook to hit  exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  return (
    <div className="table-responsive">
      {/* ========= MaterialReactTable start ======= */}
      <MaterialReactTable
        columns={tableColumns}
        data={specificAudianceData}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        state={{ rowSelection }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
      {/* ========= MaterialReactTable end ======= */}
    </div>
  );
};

export default SpecificAudienceBody;
